import styles from '../../assets/styles/LandingPage/Article.module.scss';
import React from 'react';
import Header3 from './Header3';
import Footer from './Footer';
import { MimaButton, MimaText } from '../../components';
import img_benefit2 from '../../assets/img/img_benefit2.png';
import PlayStoreIcon from '../../assets/img/playstore.png';
import AppleStoreIcon from '../../assets/img/apple.png';
import constant from '../../utils/constant';
import { useNavigate } from 'react-router';
import { otherArticles } from '../../utils/utils';
import { Link } from 'react-router-dom';

const Article1 = () => {

    const appleIcon = <img src={AppleStoreIcon} className={styles.btn__icon} alt="Apple icon" />;

    const playIcon = <img src={PlayStoreIcon} className={styles.btn__icon} alt="Playstore icon" />;

    const navigate = useNavigate();

    const switchToSignup = () => {
        navigate(constant.Routes.SignUp);
    };

    const otherArticlesfiltered = otherArticles.filter((item, index) => index !== 0);



    return (
        <>
            <Header3 />
            <div className={styles.container}>
                <div className={styles.container_title}>
                    <MimaText variant="h3" align="center" color="var(--color-primary)">
                        Benefits of Digital Business Management
                    </MimaText>
                </div>
                <img
                    src={img_benefit2}
                    alt='Article'
                    className={styles.container_img}
                />
                <MimaText variant="body2" ml={1} mr={1} mb={2}>
                    Certainly, digital business management refers to the practice of using digital technologies and strategies to effectively manage and optimize various aspects of a business. It involves leveraging digital tools, platforms, and data to streamline operations, improve customer experience, and drive business growth. Digital business management encompasses a wide range of areas, including marketing, sales, operations, customer service and more.
                </MimaText>
                <MimaText variant="bodyBold" ml={1} mr={1} mb={2} align="left">
                    Key Components of Digital Business Management:
                </MimaText>
                <ol className={styles.container_list}>
                    <li><b>Digital Marketing:</b> Digital business management involves utilizing online channels such as websites, social media, search engines, and email marketing to promote products or services, attract customers, and build brand awareness. It includes activities like search engine optimization (SEO), content marketing, social media advertising, and pay-per-click (PPC) campaigns. </li>
                    <li><b>E-commerce:</b> The management of online sales and transactions is a critical aspect of digital business management. This involves setting up an e-commerce platform, managing product catalogs, optimizing the user experience, handling secure payment processes, and ensuring efficient order fulfilment and delivery. </li>
                    <li> <b>Data Analytics:</b> Digital business management relies on the collection and analysis of data to gain insights into customer behavior, market trends, and business performance. Data analytics helps make informed decisions, identify improvement opportunities, and personalize customer experiences. It involves tools like data tracking, customer segmentation, predictive modeling, and reporting. </li>
                    <li><b>Customer Relationship Management (CRM):</b> Effective customer management is crucial for the success of any business. Digital business management incorporates CRM systems to centralize customer data, track interactions, manage leads, and facilitate personalized communication. CRM enables businesses to provide better customer service, nurture relationships, and drive customer loyalty. </li>
                    <li><b>Supply Chain and Operations:</b> Digital technologies play a vital role in managing the supply chain and optimizing operational processes. Businesses use digital tools for inventory management, procurement, logistics, and production planning. Automation, machine learning, and artificial intelligence (AI) are often employed to enhance efficiency, reduce costs, and improve overall supply chain performance. </li>
                    <li><b>Collaboration and Communication:</b> Digital business management emphasizes the use of collaboration tools and platforms to enhance communication and teamwork. Project management software, video conferencing tools, instant messaging apps, and cloud-based document sharing facilitate seamless collaboration among team members, regardless of their physical locations. </li>
                    <li><b>Security and Privacy:</b> With the increasing reliance on digital technologies, cybersecurity and data privacy become crucial considerations. Digital business management involves implementing robust security measures to protect sensitive data, preventing unauthorized access, and complying with relevant regulations such as the General Data Protection Regulation (GDPR) or other data protection. </li>
                </ol>

                <MimaText variant="bodyBold" ml={1} mr={1} mb={2} align="left">
                    Benefits of Digital Business Management:
                </MimaText>
                <ul className={styles.container_list}>
                    <li><b>Enhanced Efficiency:</b> Digital tools and automation streamline business processes, reduce manual tasks, and improve productivity.
                    </li>
                    <li><b>Improved Customer Experience:</b> Digital channels enable businesses to offer personalized experiences, faster response times, and convenient interactions, leading to higher customer satisfaction. </li>
                    <li><b>Expanded Market Reach:</b> Digital marketing and e-commerce platforms enable businesses to target a broader audience, reach customers globally, and explore new markets. Data-Driven Decision-Making: By leveraging data analytics, businesses can gain valuable insights into customer behavior, market trends, and performance metrics, enabling data-driven decision-making. </li>
                    <li><b>Competitive Advantage:</b> Embracing digital business management strategies allows companies to stay ahead of the competition by adopting innovative technologies, responding to market changes quickly, and delivering superior customer experiences.</li>
                </ul>
                <MimaText variant="body2" ml={1} mr={1} mb={2} align="left"> <span style={{ fontWeight: "700", cursor: "pointer", color: "var(--color-primary)" }} onClick={switchToSignup}>CLICK HERE</span> to sign up today and start enjoying the benefits of Mima Business.</MimaText>
                <div className={styles.slide__text_btn}>
                    <a
                        href="https://play.google.com/store/apps/details?id=com.mima.mima"
                        style={{ textDecoration: 'none' }}>
                        <MimaButton
                            title="Get app on Android"
                            variant="outlined"
                            icon={playIcon}
                            width={30}
                        />
                    </a>

                    <a
                        href="https://apps.apple.com/us/app/mima-business/id6444887331"
                        style={{ textDecoration: 'none' }}>
                        <MimaButton
                            title="Get app on iPhone"
                            variant="outlined"
                            icon={appleIcon}
                            width={30}
                        />
                    </a>
                </div>

                <MimaText mt={2} mb={2} variant="smallBold">Related Articles</MimaText>
                <div className={styles.related}>
                    {otherArticlesfiltered.map((x, i) => (
                        <Link key={i} to={x.link} className={styles.related__card}>
                            <img
                                src={x.src}
                                alt={x.title}
                            />
                            <MimaText variant="bodyBold" mt={2}>{x.title}</MimaText>
                            <MimaText variant="smallBold" color="var(--color-primary)" mt={2}>Click Here</MimaText>
                        </Link>
                    ))}
                </div>

            </div>
            <Footer />
        </>
    )
}
export default Article1;